import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DELETE_INVESTOR_INFO } from "./apiRoutes";

const mutateDeleteInvestorInfo = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${DELETE_INVESTOR_INFO}/${id}`);
};

const useDeleteInvestorInfoMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteInvestorInfo,
    ...queryParams,
  });

export default useDeleteInvestorInfoMutation;
